import { usersRoutes } from '../routes'
import { ROLES } from '../config/Constants'

export default async (level) => {
    return new Promise((resolve) => {
        const fetchEmails = async () => {
            const admin = await usersRoutes.findByRole(ROLES.ADMIN)
            const data = await usersRoutes.findByRole(ROLES.SAP_EXECUTIVE)
            const data1 = await usersRoutes.findByRole(ROLES.SHIFT_MANAGER)
            const data2 = await usersRoutes.findByRole(ROLES.CHIEF_MACHINERY)
            const admins = admin.data
            const sapExecutives = data.data
            const chiefMachineries = data1.data
            const shiftManagers = data2.data
            const emails = []
            admins.forEach((admin, index) => {
                emails.push(admin.email)
                if (index === (admins.length - 1)) {
                    sapExecutives.forEach((user, i) => {
                        emails.push(user.email)
                        if (i === (sapExecutives.length - 1)) {
                            if (level === 1) {
                                chiefMachineries.forEach((u, n) => {
                                    emails.push(u.email)
                                    if (n === (chiefMachineries.length - 1)) {
                                        shiftManagers.forEach((s, x) => {
                                            emails.push(s.email)
                                            if (x === (shiftManagers.length - 1)) {
                                                resolve(emails.toString())
                                            }
                                        })
                                    }
                                })
                            } else if (level === 2) {
                                chiefMachineries.forEach((u, n) => {
                                    emails.push(u.email)
                                    if (n === (chiefMachineries.length - 1)) {
                                        resolve(emails.toString())
                                    }
                                })
                            } else if ((level === 3) || (level === 4)) {
                                resolve(emails.toString())
                            } else {
                                resolve(emails.toString())
                            }
                        }
                    })
                }
            })
        }
        fetchEmails()
    })
}
